module.exports = __webpack_public_path__ + "img/exterior_5.4fd3ee07.jpg";